import { useMemo } from 'react'
import { useSearchParams } from 'react-router'
import { CardContent, CardFooter } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table'

export function RegistryCredentialsTableSkeleton() {
  const [searchParams] = useSearchParams()
  const ROWS = useMemo(
    () => Number(searchParams.get('limit') ?? '10'),
    [searchParams]
  )

  return (
    <>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/50 hover:bg-muted/50">
                <TableHead>
                  <Skeleton className="h-6 w-20 rounded" />
                </TableHead>
                <TableHead>
                  <Skeleton className="h-6 w-20 rounded" />
                </TableHead>
                <TableHead>
                  <Skeleton className="h-6 w-20 rounded" />
                </TableHead>
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array.from({ length: ROWS }).map((_, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <div className="px-2 flex items-center gap-2">
                      <Skeleton className="size-4 rounded-full" />
                      <Skeleton className="h-5 w-32 rounded" />
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="px-2">
                      <Skeleton className="h-4 w-48 rounded" />
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="px-2">
                      <Skeleton className="h-4 w-24 rounded" />
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="px-2 flex justify-end">
                      <Skeleton className="size-7 rounded-md" />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
      <CardFooter className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-20 rounded" />
          <Skeleton className="h-8 w-20 rounded-md" />
        </div>
        <div className="flex items-center justify-center">
          <Skeleton className="h-4 w-20 rounded" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
        </div>
      </CardFooter>
    </>
  )
}
